import { Paper, Typography, TextButton } from 'bonfire-kindling';
import { useTranslation } from 'react-i18next';
import useSendConfirmEmail from './hooks/useSendConfirmEmail';

const Unconfirmed = () => {
  const { t } = useTranslation();
  const [isLoading, sendConfirmEmail] = useSendConfirmEmail();

  return (
    <Paper
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <Typography variant="h1" component="h1">
        {t('login.confirm_account')}
      </Typography>
      <Typography sx={{ my: theme => theme.spacing(3) }}>
        {t('login.please_confirm_body')}
      </Typography>
      <TextButton
        onClick={sendConfirmEmail}
        isBusy={isLoading}
        variant="contained"
        label={t('login.send_confirmation_email')}
      />
    </Paper>
  );
};

export default Unconfirmed;
